export default __webpack_public_path__ + "static/media/praying.0a802456.png";